import { useEffect } from 'react';

import { useConflictReview } from '../../../ReorderingScreen/hooks';
import { useCheckoutContext } from '../../CheckoutProvider';

export const useConnectedDeliveryReorder = () => {
  const context = useCheckoutContext();

  useDeliveryReorder(context);
};

// Triggers delivery reorder if needed.
export const useDeliveryReorder = (
  props: Pick<
    ReturnType<typeof useCheckoutContext>,
    'cart' | 'needsReorder' | 'orderAddress' | 'isChangingOrderAddress'
  >,
) => {
  const { cart, needsReorder, orderAddress, isChangingOrderAddress } = props;

  const conflictReview = useConflictReview();

  useEffect(() => {
    if (!needsReorder || isChangingOrderAddress) return;

    void conflictReview({
      remainOnCheckout: true,
      orderId: cart?.id,
      orderType: 'delivery',
      restaurantId: cart?.restaurant?.id ?? '',
      restaurantSlug: cart?.restaurant?.slug ?? '',
      restaurantName: cart?.restaurant?.name ?? '',
      deliveryAddressName: orderAddress?.name ?? '',
      deliveryOrderDetail: {
        addressId: orderAddress?.id ?? '',
        deliveryFee: cart?.deliveryOrderDetail?.deliveryFee ?? 0,
        tip: cart?.deliveryOrderDetail?.tip ?? 0,
        vendor: cart?.deliveryOrderDetail?.vendor ?? '',
        vendorRestaurantId: cart?.deliveryOrderDetail?.vendorRestaurantId ?? '',
      },
    });
  }, [
    needsReorder,
    isChangingOrderAddress,
    cart?.id,
    cart?.restaurant?.id,
    cart?.restaurant?.slug,
    cart?.restaurant?.name,
    cart?.deliveryOrderDetail?.deliveryFee,
    cart?.deliveryOrderDetail?.tip,
    cart?.deliveryOrderDetail?.vendor,
    cart?.deliveryOrderDetail?.vendorRestaurantId,
    orderAddress?.name,
    orderAddress?.id,
    conflictReview,
  ]);
};
